import {Modal} from 'antd';

interface ConfirmationModalProps {
    title: React.ReactNode;
    content: React.ReactNode;
    onOk: () => Promise<void> | void;
    onCancel?: () => void;
}

export const createConfirmationModal = (
    {
        title,
        content,
        onOk,
        onCancel,
    }
        : ConfirmationModalProps): void => {
    const modal = Modal.info({
        title: <div className='h3 popup-title popup-title-modal'>{title}</div>,
        content: <div className='popup-text'>{content}</div>,
        okText: 'Да',
        cancelText: 'Нет',
        onOk: async () => {
            await onOk();
            modal.destroy();
        },
        onCancel: () => {
            onCancel && onCancel();
            modal.destroy();
        },
        footer: (
            <div style={{display: 'flex', gap: '20px', width: '100%'}}>
                <button
                    style={{width: '100%'}}
                    className="btn secondary"
                    onClick={() => {
                        onCancel && onCancel();
                        modal.destroy();
                    }}
                >
                    Нет
                </button>
                <button
                    style={{width: '100%'}}
                    className="btn order2-desktop"
                    onClick={async () => {
                        await onOk();
                        modal.destroy();
                    }}
                >
                    Да
                </button>
            </div>
        ),
    });
};
